/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowUpLeft: {
  name: 'arrow_up_left';
  data: string;
} = {
  name: 'arrow_up_left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M5.713 5.307a.748.748 0 0 0-.242.161l-.001.002-.002.001A.748.748 0 0 0 5.25 6v9.75a.75.75 0 0 0 1.5 0V7.81l10.72 10.72a.75.75 0 1 0 1.06-1.06L7.81 6.75h7.94a.75.75 0 0 0 0-1.5H6a.748.748 0 0 0-.287.057Z" fill="currentColor"/></svg>`
};
